import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { TIPO_COMPROBANTE } from "../../../utils/constants";

const useStyles = makeStyles({
  dialog: {
    alignSelf: 'start'
  }
});


export const ModalDetalleComprobante = (props) => {
  const classes = useStyles();
  const { detalleComprobante } = useSelector((state) => state.ctaCte);

  const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="form-dialog-title"
      classes={{ paper: classes.dialog }}
    >
      <DialogTitle id="form-dialog-title">Detalle Comprobante</DialogTitle>
      <DialogContent style={{ marginBottom: "1.5rem" }}>
        {detalleComprobante.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">Fecha</TableCell>
                <TableCell align="left">Nro Comprobante</TableCell>
                <TableCell align="left">Tipo</TableCell>
                <TableCell align="left">Nro Lote</TableCell>
                <TableCell align="left">Nro Cupón</TableCell>
                <TableCell align="left">Medio Pago</TableCell>
                <TableCell align="center">Importe</TableCell>
                <TableCell align="center">Saldo</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {detalleComprobante.map((comprobante, index) => (
                <TableRow key={index}>
                  <TableCell align="left">
                    {new Date(comprobante.fechaComprobante2).toLocaleString(
                      "es",
                      optionsfecha
                    )}
                  </TableCell>
                  <TableCell align="left">
                    {comprobante?.idTipoComprobante === TIPO_COMPROBANTE.FACTURA
                      ? comprobante.nroComprobante2
                      : comprobante.nroComprobante}
                  </TableCell>
                  <TableCell align="left">
                    {comprobante.descripcionTipoComprobante}
                  </TableCell>
                  <TableCell align="left">{comprobante.nroLote}</TableCell>
                  <TableCell align="left">{comprobante.nroCupon}</TableCell>
                  <TableCell align="left">{comprobante.medioPago}</TableCell>
                  <TableCell align="center" style={{ minWidth: 100 }}>
                    {comprobante.importe < 0
                      ? `-$${Math.abs(comprobante.importe).toFixed(2)}`
                      : `\u00A0$${comprobante.importe.toFixed(2)}`}
                  </TableCell>
                  <TableCell align="center">
                    {comprobante.nroComprobante2 ===
                      comprobante.nroComprobante &&
                      (comprobante.saldo < 0
                        ? `-$${Math.abs(comprobante.saldo).toFixed(2)}`
                        : `\u00A0$${comprobante.saldo.toFixed(2)}`)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography
            style={{
              textAlign: "center",
              fontStyle: "italic",
            }}
          >
            No hay datos
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};
